// extracted by mini-css-extract-plugin
module.exports = {"badge":"CountBadge_badge__lb8UG","light":"CountBadge_light__2Ebby"};